import React, { ReactNode, useState } from 'react';
import { GestureResponderEvent, Modal, Pressable, StyleSheet, Text, View } from 'react-native';
import ToastManager from 'toastify-react-native';
import { Platform } from 'utils/platform';

import { Icons } from 'components/Icons';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';

type MenuProps = {
  isOpen: boolean;
  onClose: () => void;
  trigger: ReactNode;
  children: ReactNode;
  placement?: 'top-right' | 'top-right-mobile';
  backgroundColor?: string;
};

export const Menu: React.FC<MenuProps> = ({
  isOpen,
  onClose,
  trigger,
  children,
  placement = 'top-right',
  backgroundColor = '#15161C',
}) => {

  const modalPositionTop = useBreakpointValueGS({
    sm: 50,
    base: 32,
  });

  const modalPositionRight = useBreakpointValueGS({
    sm: 164,
    base: 25,
  });

  const CustomToast = ({ text1, text2, hide }: any) => {
    return (
      <View
        style={{
          flexDirection: 'row',
          backgroundColor: '#070d31',
          borderWidth: 1,
          borderColor: '#fff',
          paddingHorizontal: 16,
          paddingVertical: 12,
          borderRadius: 4,
          margin: 12,
        }}>
        <Icons.SolidCheck
          width="18"
          height="18"
          stroke="currentColor"
          style={{ color: '#fff', marginRight: 12, marginTop: 4 }}
        />
        <View style={{ flex: 1, gap: 4 }}>
          <Text
            style={{ color: '#f5f5f5', fontFamily: 'system-ui', fontWeight: '700', fontSize: 16 }}>
            {text1}
          </Text>
          <Text style={{ color: '#f5f5f5', fontFamily: 'system-ui', fontSize: 14, marginTop: 4 }}>
            {text2}
          </Text>
        </View>
        <Pressable onPress={hide} style={{ marginTop: 4 }}>
          <Icons.Xmark width="18" height="18" stroke="currentColor" style={{ color: '#d1d1d1' }} />
        </Pressable>
      </View>
    );
  };

  const toastConfig = {
    custom: (props) => <CustomToast {...props} />,
  };

  return (
    <>
      {/* Trigger do menu */}
      {trigger}

      {/* Modal com fundo semitransparente */}
      <Modal visible={isOpen} transparent animationType="fade" onRequestClose={onClose}>
        <Pressable style={{ flex: 1 }} onPress={onClose}>
          <View
            style={[
              styles.menuContainer,
              { backgroundColor },
              placement === 'top-right'
                ? { right: modalPositionRight, top: modalPositionTop }
                : {
                    right: Platform.OS === 'android' ? 15 : 20,
                    top: Platform.OS === 'android' ? 15 : 65,
                  },
            ]}>
            {children}
          </View>
        </Pressable>
      </Modal>
      {Platform.OS === 'web' && <ToastManager config={toastConfig} />}
    </>
  );
};

type MenuItemProps = {
  onPress?: (event: GestureResponderEvent) => void;
  children: ReactNode;
  disabled?: boolean;
  style?: object;
};

export const MenuItem: React.FC<MenuItemProps> = ({
  onPress,
  children,
  disabled = false,
  style: { backgroundColor, ...style },
}) => {
  return (
    <Pressable
      onPress={disabled ? undefined : onPress}
      android_ripple={{ color: '#444' }}
      style={({ focused, hovered }: any) => [
        styles.menuItem,
        style,
        { backgroundColor: focused || hovered ? backgroundColor : 'transparent' },
      ]}>
      {children}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  menuContainer: {
    position: 'absolute',
    minWidth: 200,
    zIndex: 100000,
    borderRadius: 4,
    paddingRight: 10,
    paddingVertical: 8,
    marginTop: 8,
  },
  menuItem: {
    padding: 12,
  },
  menuItemPressed: {
    backgroundColor: '#333',
  },
});
